import { Component } from '@theme/component';

// setTimeout overflows above ~24.8 days, so long waits are re-checked in steps.
const MAX_TIMEOUT = 2 ** 31 - 1;

/** @param {number} value */
const pad = (value) => String(value).padStart(2, '0');

/** Ticking sale countdown. Hidden before data-start, removed after data-end (unix seconds). */
class SaleCountdown extends Component {
  /** @type {number | undefined} */
  #timer;

  connectedCallback() {
    super.connectedCallback();
    this.#tick();
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    window.clearTimeout(this.#timer);
  }

  #tick = () => {
    const now = Date.now();
    const start = Number(this.dataset.start) * 1000;
    const end = Number(this.dataset.end) * 1000;

    if (!end || now >= end) {
      this.remove();
      return;
    }

    if (now < start) {
      this.hidden = true;
      this.#timer = window.setTimeout(this.#tick, Math.min(start - now, MAX_TIMEOUT));
      return;
    }

    this.hidden = false;

    let remaining = Math.floor((end - now) / 1000);
    const days = Math.floor(remaining / 86400);
    remaining %= 86400;

    this.#set('days', String(days));
    this.#set('hours', pad(Math.floor(remaining / 3600)));
    this.#set('minutes', pad(Math.floor((remaining % 3600) / 60)));
    this.#set('seconds', pad(remaining % 60));

    const daysWrap = this.querySelector('[data-countdown-days-wrap]');
    if (daysWrap instanceof HTMLElement) daysWrap.hidden = days === 0;

    // Align ticks to the start of each second so the display never skips.
    this.#timer = window.setTimeout(this.#tick, 1000 - (now % 1000));
  };

  /**
   * @param {string} unit
   * @param {string} value
   */
  #set(unit, value) {
    const element = this.querySelector(`[data-countdown="${unit}"]`);
    if (element && element.textContent !== value) element.textContent = value;
  }
}

if (!customElements.get('sale-countdown')) customElements.define('sale-countdown', SaleCountdown);
